import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCurrencyList(params) {
  return request({
    url: URL.mdm.basicData.currency,
    method: 'get',
    params
  })
}

export function getNoPaginationCurrencyList(params) {
  return request({
    url: URL.mdm.basicData.allCurrency,
    method: 'get',
    params
  })
}

export function getCurrenciesByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformCurrency,
    method: 'get',
    params
  })
}

export function getAllCurrencyTemplate(params) {
  return request({
    url: URL.mdm.basicData.currencyTemplate,
    method: 'get',
    params
  })
}

export function saveCurrency(data) {
  return request({
    url: URL.mdm.basicData.currency,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addCurrencyByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformCurrency,
    method: 'post',
    data
  })
}

export function saveCurrencies(data) {
  return request({
    url: URL.mdm.basicData.currencies,
    method: 'post',
    data
  })
}

export function delCurrency(uuid) {
  return request({
    url: URL.mdm.basicData.currency + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
